import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const DomainNameContainer = styled.div`
  width: 150px;
`;

const DownloadButtonContainer = styled.div`
  margin-left: 20px;
  margin-top: 20px;
  position: relative;
`;

const CompanyInputContainer = styled.div`
  width: 300px;

  label {
    font-size: 1em;
  }

  input {
    font-size: 1.2em;
  }
`;

const LogoUploadButtonContainer = styled.div`
  height: 100%;
  width: 100%;

  input {
    width: 150px;
    margin-right: 10px;
  }
`;

const LogoUploadContainer = styled.div`
  flex-direction: column;
`;

const LogoContainer = styled.div`
  img {
    height: 100px;
  }
`;

const Row = styled.div`
  padding: 20px 0;
  width: 100%;
  display: flex;
`;

const Left = styled.div`
  padding-right: 50px;
  width: 50%;
  display: flex;
  justify-content: flex-end;
`;

const Right = styled.div`
  padding-left: 50px;
  width: 50%;
  display: flex;
  justify-content: flex-start;
`;

const Spacer = styled.div`
  height: 10px;
`;

const InvoiceInputContainer = styled.div``;
const PaymentReceiptInputContainer = styled.div``;
const PaymentPlanContainer = styled.div``;
const PaymentModeContainer = styled.div``;

const ButtonContainer = styled.div`
  width: 200px;
  margin-top: 30px;
  position: relative;
`;

const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SnackbarMessage = styled.span``;

const BlockButtonContainer = styled.div`
  width: 200px;
  margin-top: 80px;
  position: relative;
`;

const PlanDuration = styled.div`
  flex-direction: row;
`;

const PresetDurations = styled.div`
  flex-direction: row;
  margin-top: 10px;
`;

const DatePicker = styled.div`
`;

export default {
  Container,
  Header,
  CompanyInputContainer,
  DownloadButtonContainer,
  Row,
  Left,
  Right,
  Spacer,
  InvoiceInputContainer,
  PaymentReceiptInputContainer,
  PaymentPlanContainer,
  PaymentModeContainer,
  DomainNameContainer,
  ButtonContainer,
  Loader,
  SnackbarMessage,
  BlockButtonContainer,
  LogoUploadButtonContainer,
  LogoContainer,
  LogoUploadContainer,
  PlanDuration,
  PresetDurations,
  DatePicker
};



// WEBPACK FOOTER //
// ./src/pages/ExperimentsList/styles.js